import React from "react";
import classes from "../NotLoggedIn/NotLoggedIn.module.scss";
import Button from "../UI/Button";
import axios from "axios";
import { useNavigate, useLocation } from "react-router-dom";

const apiRequestAddress =
  process.env.REACT_APP_API_ENDPOINT || window.location.origin + "/json.rpc";

const NotMainOrg = ({ onRequireRerender }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const onBtnClickHandler = () => {
    axios
      .post(
        apiRequestAddress,
        {
          jsonrpc: "2.0",
          method: "Auth.ChangeOrganization",
          params: {
            orgid: `${sessionStorage.getItem("mainOrgId")}`,
          },
          id: 1111,
        },
        {
          withCredentials: true,
        }
      )
      .then((res) => {
        if (res?.data?.result?.toLowerCase() === "ok") {
          navigate(location.pathname);
          onRequireRerender();
        }
      });
  };

  return (
    <div className="h-100 w-100 d-flex align-items-center justify-content-center flex-column px-5 text-center">
      <h2 className={`h4 ${classes.text}`}>
        You are currently logged in as one of your customers. Please switch back
        to your main organisation's profile to gain access.
      </h2>
      <Button
        className={`px-4 py-1 mt-2 ${classes.btn}`}
        onClick={onBtnClickHandler}
      >
        Switch back to main profile
      </Button>
    </div>
  );
};

export default NotMainOrg;
